import React from 'react'
import contactoHome from '../../img/contactanos.jpg';
import { Link } from 'react-router-dom';
const Contactanos = () => {
   return (
      <div className="bg-latitud animated fadeIn" >
         <div className="container section">
            <div className="row">
               <div className="center-vertical">
                  <div className="col s12 m12 l6 x6 center">
                     <img src={contactoHome} className="circle responsive-img" height="300" width="300"/>
                  </div>
                  <div className="col s12  m12 l6  x6 center text-white">
                     <strong style={{"font-size":"24px"}}>¡Contáctanos para todas tus consultas!</strong><br/><br/><br/>
                     <Link to={"/contacto"} className="btn btn-large waves-effect waves-light text-gray  white pulse" type="submit" name="action">Ver más
                        <i className="material-icons right">send</i>
                     </Link>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Contactanos